<template>
  <div
    class="custom-empty-tips"
    :style="{height: height}"
  >
    <div class="tips">{{text}}</div>
  </div>
</template>

<script>
export default {
  name: '',
  mixins: [],
  components: {
  },
  props: {
    text: {
      type: String,
      default() {
        return this.$t('Common.com_no_data');
      }
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.custom-empty-tips {
  min-height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .tips {
    text-align: center;
    width: 50%;
    line-height: 60px;
    font-size: 12px;
    color: #909399;
  }
}
</style>
